import React, { useEffect, useState } from "react";
import { Button, Divider, Menu } from "antd";
import { FaUsers, FaVolleyballBall } from "react-icons/fa";
import {
  GiAmericanFootballHelmet,
  GiAmericanFootballPlayer,
  GiBasketballBasket,
  GiBoxingGloveSurprise,
  GiHockey,
  GiSoccerBall,
} from "react-icons/gi";
import type { MenuProps } from "antd";
import { useUser } from "../../../DataProvider";
import { Link } from "react-router-dom"; // Import Link from React Router
import {
  ArrowLeftOutlined,
  ArrowRightOutlined,
  QuestionCircleOutlined,
  StarOutlined,
} from "@ant-design/icons";
import {
  MdArticle,
  MdFilterList,
  MdPayment,
  MdSportsRugby,
} from "react-icons/md";
import { FaBasketballBall } from "react-icons/fa";
import { GiRaceCar } from "react-icons/gi";
import { FaBaseballBatBall } from "react-icons/fa6";
import { TbPlayHandball } from "react-icons/tb";
import { PiCards } from "react-icons/pi";
import { CiAlignTop, CiGlobe } from "react-icons/ci";
import { CgWebsite } from "react-icons/cg";

type MenuItem = Required<MenuProps>["items"][number];

type MenuItemWithChildren = MenuItem & { children?: MenuItem[] };

const menuItems: MenuItem[] = [
  {
    key: "0",
    icon: <MdPayment />,
    label: <Link to="/payment-methods">Payment Methods</Link>,
  },
  {
    key: "2",
    icon: <CiGlobe />,
    label: <Link to="/languages">Languages</Link>,
  },
  {
    key: "2",
    icon: <StarOutlined />,
    label: <Link to="/features">Features</Link>,
  },
  {
    key: "3",
    icon: <QuestionCircleOutlined />,
    label: <Link to="/questions">Questions</Link>,
  },
  {
    key: "4",
    icon: <PiCards />,
    label: <Link to="/betting-websites">Betting Websites</Link>,
  },
  {
    type: "divider",
  },
  {
    key: "5",
    icon: <MdArticle />,
    label: <Link to="/articles">Articles</Link>,
  },
  {
    type: "divider",
  },
  {
    key: "6",
    icon: <CiAlignTop />,
    label: <Link to="/top10-articles">Top10 Articles</Link>,
  },
  {
    key: "7",
    icon: <CgWebsite />,
    label: <Link to="/main-websites">Main Websites</Link>,
  },
];

const App: React.FC = () => {
  const [filteredItems, setFilteredItems] = useState<MenuItem[]>([]);
  const [collapsed, setCollapsed] = useState(false);
  const { user } = useUser();

  return (
    <div>
      <Button className=" w-full" onClick={() => setCollapsed(!collapsed)}>
        {collapsed ? <ArrowRightOutlined /> : <ArrowLeftOutlined />}
      </Button>
      <Menu
        inlineCollapsed={collapsed}
        mode="inline"
        className={collapsed ? " w-auto" : "w-80"}
        items={menuItems}
      />
    </div>
  );
};

export default App;
